import { VALUEDCHANGES_FETCH } from "../../actions/others/valuedChangeActions";

const valuedChangeReducer = (state: any[] = [], action: any) => {
  switch (action.type) {
    case VALUEDCHANGES_FETCH:
      return action.payload;
    default:
      return state;
  }
};

export default valuedChangeReducer;
